// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__EwRTl","main-image":"Header_main-image__2cD55"};